import React from 'react'
import { ForEachModel, Selection, useValue, ValueToCollection, WhenModelValue } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { ProductInfo } from 'ui'
import * as Displays from 'support/displays'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Translation } from '@morningtrain/react-translations'
import SetSelectedItems from 'pages/app/inventory/supplier/SetSelectedItems'
import SelectedItemFields from 'pages/app/inventory/supplier/SelectedItemFields'

export default function SupplierDepartmentCategories () {
  const itemIdsByCategory = useValue('item_ids_by_category')

  return (
    <ForEachModel>
      <WhenModelValue name='chosen_items' condition={v => !!v && v.length > 0}>
        <UI.Card>
          <UI.CardHeader>
            <UI.SecondaryHeading>
              <Displays.Text name='name' />
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <ValueToCollection name='items'>
            <Selection>
              <SetSelectedItems itemIdsByCategory={itemIdsByCategory} />
              <SelectedItemFields />
              <Table selectOnClick selectMultiple>
                <Columns.Checkbox />
                <Columns.Column className='w-full' label={<Translation name='columns.name.label' />}>
                  <ProductInfo
                    image={<Displays.Image name='image' lazy className='max-h-full' />}
                    title={<Displays.Text name='name' />}
                    text={(<>min. <Displays.Integer name='min_unit' /> <Displays.Text name='unit_type' /></>)}
                  />
                </Columns.Column>
              </Table>
            </Selection>
          </ValueToCollection>
        </UI.Card>
      </WhenModelValue>
    </ForEachModel>
  )
}
